<template>
  <Page :bottomPadding="false">
    <div class="flex h-full">
      <div
        class="text-white-040 mr-2"
        style="box-shadow: 4px 0px 4px 0px rgba(0, 0, 0, 0.3)"
      >
        <div
          class="sticky pt-12 pr-2"
          style="top: 72px; height: calc(100vh - 144px)"
        >
          <div v-for="(tab, i) in tabs" :key="i" @click="onTabClick(i)">
            <div
              class="
                nav-item
                relative
                w-44
                h-10
                pl-4
                rounded
                flex
                items-center
                font-bold
              "
              :class="{
                'text-white-070':
                  !tab.disabled && !(tab.status || tab.selected),
                'text-whitebase ': tab.status || tab.selected,
                ' bg-white-010':
                  isEditDao && tab.children && tab.children.length > 0
                    ? false
                    : $route.path.indexOf(tab.path) != -1,
                'cursor-pointer': !tab.disabled,
                'cursor-not-allowed': tab.disabled,
              }"
            >
              <span>
                {{ tab.name }}
              </span>

              <div
                class="ml-2 transform transition-all"
                :class="{
                  'rotate-90': tab.selected,
                }"
                v-if="tab.children"
              >
                <i class="iconfont icon-right"></i>
              </div>

              <i
                v-if="tab.status"
                class="
                  iconfont
                  icon-gou
                  absolute
                  right-1
                  top-1/2
                  text-green-500
                  transform
                  -translate-y-1/2
                "
              ></i>
            </div>
            <div class="text-white-040" v-if="tab.selected">
              <div
                class="pl-8 text-sm h-10 flex items-center relative"
                v-for="(sub, i) in tab.children"
                :key="i"
                :class="{
                  'text-white-070':
                    !tab.disabled && !(sub.selected || sub.status),
                  'text-whitebase': sub.selected || sub.status,
                  'bg-white-010': sub.selected,
                  'cursor-pointer': !tab.disabled,
                  'cursor-not-allowed': tab.disabled,
                }"
                @click.stop="$router.replace(sub.path)"
              >
                {{ sub.name }}

                <!-- <i
                  v-if="sub.status"
                  class="
                    iconfont
                    icon-gou
                    absolute
                    right-1
                    top-1/2
                    text-green-500
                    transform
                    -translate-y-1/2
                  "
                ></i> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- content -->
      <div
        class="flex-1 min-w-0 relative h-full pl-6 pb-24"
        v-if="!isEditDao || !loading"
      >
        <router-view></router-view>
      </div>
      <div
        class="
          flex-1
          min-w-0
          relative
          h-full
          pl-6
          pb-24
          flex
          items-center
          justify-center
          text-whitebase
        "
        v-else
      >
        <Spin size="3em"></Spin>
      </div>
    </div>
  </Page>
</template>

<script setup>
import {
  reactive,
  watchEffect,
  watch,
  provide,
  computed,
  onMounted,
  onUnmounted,
} from 'vue';
import Page from '@/components/Page.vue';
import Spin from '@/components/Spin.vue';
import { useRoute, useRouter } from 'vue-router';
import { withThrottling } from '@/utils/with';
import { mittLoading } from '@/libs/event';
import { useIsSigned, useReqByBool } from '@/hooks';
import {
  getDaoIdByPath,
  queryEditDaoInfo,
  queryEditGovernance,
  queryEditPass,
  queryEditTreasury,
  sureCreateDao,
  queryEditEvents,
} from '@/api/dao';
import { notify } from '@kyvg/vue3-notification';
import mitt from '@/libs/event';
import {
  passTypeMap,
  typeType,
  useIsEditDao,
  NetworkType,
  platformTypes,
} from './constanst';
import { uuid } from '@/utils';

const $route = useRoute();
const $router = useRouter();

const formInfo = reactive({
  /* flag */
  id: null,
  /* dao */
  name: '',
  intro: '',
  logo: '',
  daoTag: [],
  daoType: '',
  website: '',
  whitepaper: '',
  twitter: '',
  openseaUrl: '',
  superrareUrl: '',
  foundationUrl: '',
  customizeLink: [],
  discordLinkUrl: '',
  telegramLinkUrl: '',
  mirrorUrl: '',
  daoCategory: 0,
  structure: '',
  daoRelationship: [],

  // id: 1186,
  // name: 'qscre',
  // intro:
  //   'File types Supported:\nJPG, PNG, GIF, SVG.Max size: 100 MFile types Supported:\nJPG, PNG, GIF, SVG.Max size: 100 MFile types Supported:\nJPG, PNG, GIF, SVG.Max size: 100 MFile types Supported:\nJPG, PNG, GIF, SVG.Max size: 100 M',
  // logo: 'https://beeper-dao-red-images.s3.ap-southeast-1.amazonaws.com/a8478a5f-efc1-4661-87e2-93b22ca66fff',
  // website: 'x',
  // whitepaper: '',
  // twitter: 'x',
  // openseaUrl: '',
  // superrareUrl: '',
  // foundationUrl: '',
  // customizeLink: [],
  // discordLinkUrl: '',
  // telegramLinkUrl: '',
  // daoTag: ['x', 'x'],
  // daoType: 'Infrastructure',
  // mirrorUrl: '',
  // daoCategory: 0,
  // daoRelationship: [
  //   {
  //     relationshipType: '1',
  //     daoId: 53,
  //     name: 'DAF',
  //   },
  // ],

  /* pass */
  passName: '',
  passSymbol: '',
  passLogo: '',
  passType: '',
  passBondingCurve: {
    network: '',
    passContractType: 'ERC1155',
    collateralTokens: '',
    creatorFee: '',
    receivingAddress: '',
    platformCommission: '',
    initialPrice: '',
    m: '0.000001',
    n: 2,
    erc20Address: '',
  },
  passFixedPrice: {
    network: '',
    passContractType: 'ERC721',
    payment: '',
    payWith: '',
    validityType: 'certain_time',
    termOfValidity: '',
    certainTime: '',
    platformCommission: '',
    receivingAddress: '',
    supply: '',
    schedulingAhead: '',
    isFreeMint: false,
    /* - - */
    isWhiteList: false,
    whiteMode: 0,
    excelUuid: '',
    fileName: '',
    whiteList: [],
    duration: '',
    validityStatus: false,
    mintLimit: '',
  },
  passStakingBasedDTO: {
    network: '',
    passContractType: 'ERC721',
    tokenMintTheNftPass: 'ERC20',
    tokenContractAddress: '',
    nftContractAddress: '',
    tokensNeededToMintANft: '',
    /* - - */
    isWhiteList: false,
    whiteMode: 0,
    excelUuid: '',
    fileName: '',
    whiteList: [],
    duration: '',
    mintLimit: '',
    schedulingAhead: '',
  },
  createPass: false,
  /* add pass */
  poap: [],
  oat: [],
  collection: [],

  /* treasury */
  treasury: [],
  /* governance */
  platformLinks: [],
  memberIntro: '',
  memberImage: '',
  governanceTokenList: [],
  creatorRole: {},
  roles: [],
  eventsEmail: [],
});
provide('formInfo', formInfo);

const createState = reactive({
  daoStatus: false,
  passStatus: false,
  addPassStatus: false,
  treasuryStatus: false,
  governanceStatus: false,
  eventStatus: false,
});
provide('createState', createState);

const state = reactive({
  selected: 0,
  top: 0,
  width: 0,
});

const isEditDao = useIsEditDao();

// Pass created can't modify.
const tabs = computed(() => {
  const isEdit = isEditDao.value;

  const res = [
    {
      name: 'DAO Settings',
      path: isEdit ? `/pass_settings/${$route.params.name}/dao` : '/create/dao',
      status: createState.daoStatus,
    },
    {
      name: 'PASS Settings',
      path: isEdit
        ? `/pass_settings/${$route.params.name}/pass/${
            formInfo.passType ? passTypeMap[formInfo.passType] : ''
          }`
        : '/create/passsettings',
      disabled: !createState.daoStatus,
      status: createState.passStatus || createState.addPassStatus,
      children: [
        {
          name: 'Create PASS',
          path: isEdit
            ? `/pass_settings/${$route.params.name}/pass/${
                formInfo.passType ? passTypeMap[formInfo.passType] : ''
              }`
            : `/create/pass/${
                formInfo.passType ? passTypeMap[formInfo.passType] : ''
              }`,
          status: createState.passStatus,
        },
        {
          name: 'Add PASS',
          path: isEdit
            ? `/pass_settings/${$route.params.name}/addpass`
            : '/create/addpass',
          status: createState.addPassStatus,
        },
      ],
    },
    {
      name: 'Treasury',
      path: isEdit
        ? `/pass_settings/${$route.params.name}/treasury`
        : '/create/treasury',
      status: createState.treasuryStatus,
      disabled: !createState.daoStatus,
    },
    {
      name: 'Governance',
      path: isEdit
        ? `/pass_settings/${$route.params.name}/governance`
        : '/create/governance',
      status: createState.governanceStatus,
      disabled: !createState.daoStatus,
    },
    {
      name: 'Calendar',
      path: isEdit
        ? `/pass_settings/${$route.params.name}/calendar`
        : '/create/calendar',
      status: createState.eventStatus,
      disabled: !createState.daoStatus,
    },
  ];

  res.forEach((x) => {
    x.selected = $route.path.indexOf(x.path) > -1;

    if (isEditDao.value) {
      x.disabled = false;
      x.status = false;
    }

    if (x.name == 'PASS Settings') {
      x.selected =
        x.selected ||
        x.children.filter((y) => $route.path.indexOf(y.path) > -1).length > 0;
      x.children.forEach((z) => {
        z.selected = $route.path.indexOf(z.path) > -1;
      });
    }
  });

  return res;
});

const onTabClick = (i) => {
  if (tabs.value[i].disabled) {
    return;
  }
  state.selected = i;
  $router.replace(tabs.value[i].path);
};

watchEffect(() => {
  state.selected = tabs.value.findIndex((x) => {
    return new RegExp(x.path).test($route.path);
  });
});

const onReady = withThrottling(async () => {
  if (!formInfo.id) {
    notify({
      type: 'error',
      text: 'Have to insert information in DAO settings first!',
    });
    return;
  }

  const lid = Date.now();
  try {
    mittLoading(lid);

    const path = await sureCreateDao(formInfo.id);

    $router.replace({
      name: 'create-success',
      query: {
        name: formInfo.name,
        logo: formInfo.logo,
        path,
        id: formInfo.id,
        onlydao: !createState.passStatus,
      },
    });
  } catch (error) {
    /*  */
  }
  mittLoading(lid, false);
});

// login reload
const isSign = useIsSigned();
watch(
  () => isSign,
  () => {
    window.location.reload();
  },
);

const reqInfo = async () => {
  const id = await getDaoIdByPath($route.params.name);
  const daoInfo = await queryEditDaoInfo(id);
  const treasury = await queryEditTreasury(id);
  const governance = await queryEditGovernance(id);
  const pass = await queryEditPass(id);
  const events = await queryEditEvents(id);
  const {
    name,
    intro,
    logo,
    daoTag,
    daoType,
    website,
    whitepaper,
    twitter,
    openseaUrl,
    superrareUrl,
    foundationUrl,
    customizeLink,
    discordLinkUrl,
    telegramLinkUrl,
    mirrorUrl,
    daoCategory,
    structure,
    daoRelationship,
    passName,
    passSymbol,
    passLogo,
    passType,
    formJson,
  } = daoInfo;

  const { poap, oat, other } = pass;

  const { description, imageUrl, link, governanceTokenList, roles } =
    governance;
  formInfo.id = id;
  formInfo.name = name;
  formInfo.intro = intro;
  formInfo.logo = logo;
  formInfo.daoTag = daoTag;
  formInfo.daoType = daoType;
  formInfo.website = website;
  formInfo.whitepaper = whitepaper;
  formInfo.twitter = twitter;
  formInfo.openseaUrl = openseaUrl;
  formInfo.superrareUrl = superrareUrl;
  formInfo.foundationUrl = foundationUrl;
  formInfo.customizeLink = customizeLink;
  formInfo.discordLinkUrl = discordLinkUrl;
  formInfo.telegramLinkUrl = telegramLinkUrl;
  formInfo.mirrorUrl = mirrorUrl;
  formInfo.daoCategory = daoCategory;
  formInfo.structure = structure;
  formInfo.daoRelationship = daoRelationship;

  formInfo.passName = passName;
  formInfo.passSymbol = passSymbol;
  formInfo.passLogo = passLogo;
  formInfo.passType = ['token_base', 'nft_base'].includes(passType)
    ? 'staking_based'
    : passType;

  const temp = JSON.parse(formJson);
  if (temp) {
    formInfo.passBondingCurve = temp.passBondingCurve;
    formInfo.passFixedPrice = temp.passFixedPrice;
    formInfo.passStakingBasedDTO = temp.passStakingBasedDTO;
  }

  if (passName) {
    formInfo.createPass = true;
  }

  formInfo.treasury = treasury.list.map((x) => {
    const a = NetworkType.findIndex((y) => y.value == x.network);

    return {
      id: uuid(),
      network: NetworkType[a == -1 ? 0 : a],
      tag: x.tag,
      trackedAddress: x.trackedAddress,
    };
  });
  formInfo.poap = poap;
  formInfo.oat = oat;
  formInfo.collection = other.map((x) => {
    const index = NetworkType.findIndex((y) => y.value == x.chain);

    return {
      id: x.id,
      image: x.image,
      chain: NetworkType[index == -1 ? 0 : index],
      contract: x.address,
      link: x.link,
    };
  });
  formInfo.memberIntro = description;
  formInfo.memberImage = imageUrl;
  formInfo.platformLinks = link.map((x) => {
    const index = platformTypes.findIndex((y) => y.value == x.platform);
    return {
      link: x.link,
      platform: platformTypes[index],
    };
  });

  formInfo.governanceTokenList = governanceTokenList.map((x) => {
    const index = NetworkType.findIndex((a) => a.value == x.chain);

    return {
      id: uuid(),
      type: typeType[x.type],
      chain: NetworkType[index == -1 ? 0 : index],
      trackedAddress: x.address,
    };
  });

  const rolesx = roles.map((x) => {
    return {
      id: uuid(),
      time: x.createTime,
      address: x.address,
      identity: x.role,
    };
  });
  formInfo.creatorRole = rolesx[0];
  formInfo.roles = rolesx.slice(1);

  formInfo.eventsEmail = events.map((item) => ({ email: item }));
};

const { loadData, loading } = useReqByBool(reqInfo);

onMounted(async () => {
  if (isEditDao.value) {
    loadData();
  }
});

mitt.on('onCreateReady', onReady);
onUnmounted(() => {
  mitt.off('onCreateReady');
});
</script>

<style scoped>
.nav-line {
  position: absolute;
  left: 16px;
  bottom: -8px;
  width: 80px;
  height: 1px;
  background: #fff;
}

.nav-item.disabled {
  color: rgba(255, 255, 255, 0.4);
  cursor: not-allowed;
}
.nav-item.active {
  text-decoration: underline;
}
</style>

<style>
.ready-btn {
  padding: 0px 16px;
  height: 40px;
  background: linear-gradient(315deg, #ff5585 0%, #268cff 100%);
  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;

  font-weight: bold;
  color: white;
}
/* .ready-btn:hover {
  background: transparent;
  color: white;
} */
.ready-btn-back {
  padding: 0px 16px;
  height: 40px;
  background: transparent;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #fff;
  color: #fff;
  font-weight: bold;
}
.ready-btn-back:hover {
  background: #ffffff;
  color: #121416;
}

.drop-height {
  height: 56px;
  font-weight: normal !important;
  font-size: 16px !important;
}

.ready-btn.disabled,
.ready-btn-back.disabled {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.6;
}
</style>
